import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Ajax from '../../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from '../list-mutations';
import CouponCourt from '../../entities/booking/couponCourt';

interface CouponCourtState extends ListState<CouponCourt>{
    editCouponCourt:CouponCourt
}
class CouponCourtModule extends ListModule<CouponCourtState,any,CouponCourt>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<CouponCourt>(),
        loading:false,
        editCouponCourt:new CouponCourt()
    }
    actions={
        async getAll(context:ActionContext<CouponCourtState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/CouponCourt/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<CouponCourt>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<CouponCourtState,any>,payload:any){
            await Ajax.post('/api/services/app/CouponCourt/Create',payload.data);
        },
        async createWithImages(context:ActionContext<CouponCourtState,any>,payload:any){
            await Ajax.post('/api/services/app/CouponCourt/CreateWithImages',payload.data);
        },
        async update(context:ActionContext<CouponCourtState,any>,payload:any){
            await Ajax.put('/api/services/app/CouponCourt/Update',payload.data);
        },
        async updateWithImages(context:ActionContext<CouponCourtState,any>,payload:any){
            await Ajax.put('/api/services/app/CouponCourt/UpdateWithImages',payload.data);
        },
        async delete(context:ActionContext<CouponCourtState,any>,payload:any){
            context.state.loading=true;
            await Ajax.delete('/api/services/app/CouponCourt/Delete?Id='+payload.data.id);
            context.state.loading=false;
        },
        async get(context:ActionContext<CouponCourtState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/CouponCourt/Get?Id='+payload.id);
            return reponse.data.result as CouponCourt;
        }
    };
    mutations={
        setCurrentPage(state:CouponCourtState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:CouponCourtState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:CouponCourtState,couponCourt:CouponCourt){
            state.editCouponCourt=couponCourt;
        },
        changeLoading(state:CouponCourtState,loading:boolean){
            state.loading = loading;
        }
    }
}
const couponCourtModule=new CouponCourtModule();
export default couponCourtModule;